@import (reference) '../../../../constants/spacing.module.less';

.container {
  height: 100%;
  width: 100%;
}

.content {
  flex: 1;
  overflow-y: auto;
  padding-left: @space-16;
  padding-right: @space-16;
  width: 100%;
  max-width: 100%;
  background-color: var(--gray-F9FAFB);
}

.loading-container {
  align-items: center;
  justify-content: center;
  height: 200px;
}

.error-message {
  color: var(--red-DC3545);
  padding: @space-20;
  text-align: center;
}
